<template>
  <div class="login-container">
    <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
      label-position="left">
      
      <el-row type="flex" justify="center">
        <el-col :span="24" class="logo-container">
          <img :src="require('@/assets/img/logocybersiapSinTexto.jpg')" alt="Logo del Software" class="login-logo" />
        </el-col>
      </el-row>
      <el-row :gutter="600" type="flex" justify="center">
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span></span>
        </el-col>
        <el-col :xs="22" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="title-login">
            <h3 class="title">{{ $t('login.title') }}</h3>
            <lang-select class="set-language"></lang-select>
          </div>
        </el-col>
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span></span>
        </el-col>
      </el-row>
      <el-row :gutter="4" type="flex" justify="center">
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span></span>
        </el-col>
        <el-col :xs="22" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item prop="username">
            <el-input name="username" type="text" v-model="loginForm.username" autoComplete="on"
              :placeholder="$t('login.username')">
              <template slot="prepend">
                <span>
                  <i class="el-icon-user" />
                </span>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span>&nbsp;</span>
        </el-col>
      </el-row>
      <el-row :gutter="4" type="flex" justify="center">
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
        <el-col :xs="22" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item prop="password">
            <el-input name="password" :type="passwordType" @keyup.enter.native="handleLogin"
              v-model="loginForm.password" autoComplete="on" :placeholder="$t('login.password')">
              <template slot="prepend">
                <span>
                  <i class="el-icon-lock" />
                </span>
              </template>
              <template slot="append">
                <span class="show-pwd" @click="showPwd">
                  <i class="el-icon-view" />
                </span>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
      </el-row>
      <el-row :gutter="4" type="flex" justify="center">
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
        <el-col :xs="22" :sm="8" :md="8" :lg="8" :xl="8">
          <span><a class="password-forgot" v-on:click="recovery()">{{ $t('login.forgot') }}</a></span>
        </el-col>
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
      </el-row>
      <el-row :gutter="4" type="flex" justify="center">
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
        <el-col :xs="22" :sm="8" :md="8" :lg="8" :xl="8">
          <el-button type="primary" class="login-button" style="width:100%;margin-bottom:30px;" :loading="loading"
            @click.native.prevent="handleLogin">{{ $t('login.logIn') }}</el-button>
        </el-col>
        <el-col :xs="1" :sm="8" :md="8" :lg="8" :xl="8">
          <span />
        </el-col>
      </el-row>
      <!--
      <div class="tips">
        <span>{{$t('login.username')}} : admin</span>
        <span>{{$t('login.password')}} : {{$t('login.any')}}</span>
      </div>
      <div class="tips">
        <span style="margin-right:18px;">{{$t('login.username')}} : editor</span>
        <span>{{$t('login.password')}} : {{$t('login.any')}}</span>
      </div>

      <el-button class="thirdparty-button" type="primary" @click="showDialog=true">{{$t('login.thirdparty')}}</el-button>
-->
    </el-form>

    <el-dialog :title="$t('login.thirdparty')" :visible.sync="showDialog" append-to-body>
      {{ $t('login.thirdpartyTips') }}
      <br />
      <br />
      <br />
      <social-sign />
    </el-dialog>

  </div>
</template>

<script>
import { isvalidUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import SocialSign from './socialsignin'

export default {
  components: { LangSelect, SocialSign },
  name: 'login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error('Por favor ingrese un nombre de usuario adecuado'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('La contraseña no puede tener menos de 6 digitos'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false
    }
  },
  methods: {
    recovery() {
      this.$router.push({ path: '/recovery' })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
            this.loading = false
            this.$router.push({ path: '/empresa' })
          }).catch(() => {
            this.$message({
              message: 'Atención, Usuario y/o Contraseña inválidos, verifique sus credenciales.',
              type: 'warning',
              duration: 5000
            })
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    afterQRScan() {
      // const hash = window.location.hash.slice(1)
      // const hashObj = getQueryObject(hash)
      // const originUrl = window.location.origin
      // history.replaceState({}, '', originUrl)
      // const codeMap = {
      //   wechat: 'code',
      //   tencent: 'code'
      // }
      // const codeName = hashObj[codeMap[this.auth_type]]
      // if (!codeName) {
      //   alert('第三方登录失败')
      // } else {
      //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
      //     this.$router.push({ path: '/' })
      //   })
      // }
    }
  },
  created() {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-image: url('~@/assets/img/background_login.jpg');
  
  // Agrega flexbox para centrar contenido
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .login-form {
    background: transparent;
    width: 100%;
    max-width: 2000px;
    padding: 0px;
    margin: 0;
    margin-top: 50px;
  }

  .login-logo {
  width: 200px;
  margin-bottom: 40px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%; 
  box-shadow: 0 4px 8px rgba(25, 221, 255, 0.8);
}

  .title-login {
    text-align: center;
    margin-bottom: 10px;

    .title {
      font-size: 25px;
      color: $light_gray;
      font-weight: bold;
    }

    .set-language {
      color: #fff;
      margin-top: 10px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $light_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }

  .password-forgot {
    color: #e21a1a !important;
  }
  .login-button {
    font-size: 18px; // Ajusta el tamaño según lo necesites
  }
}
</style>
